export default [
  {
    path: '/servicos',
    name: 'Servicos',
    component: () => import(/* webpackChunkName: "Servicos" */ '../servicos/Servicos')
  },
  {
    path: '/servicos-cadastro',
    name: 'ServicosCadastro',
    component: () => import(/* webpackChunkName: "ServicosCadastro" */ '../servicos/ServicosCadastro')
  },
  {
    path: '/servicos-lista',
    name: 'ServicosLista',
    component: () => import(/* webpackChunkName: "ServicosLista" */ '../servicos/ServicosLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/servicos/router.js